import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {selectFeatures} from './selectors'
import _ from 'underscore'

export const setFeatures = createAction(ActionTypes.SET_FEATURES)

export const setEnabledFeatures = (enabledFeatures) => (dispatch, getState) => {
    dispatch(setFeatures(_.mapObject(selectFeatures(getState()), (val, feature) => {
        return !!enabledFeatures[feature]
    })))
}

export const updateFeatures = createAction(ActionTypes.UPDATE_FEATURES)



// WEBPACK FOOTER //
// ./web/js/features/actions.js